module.exports = __webpack_public_path__ + "img/vue1-languette_rouge.8e31ed18.png";